import React from 'react'
import { render } from 'react-dom'

/* eslint-disable import/no-extraneous-dependencies */
import { AppContainer } from 'react-hot-loader'
import RedBox from 'redbox-react'
import App from './App'
/* eslint-enable import/no-extraneous-dependencies */

import LoadingInfo from './LoadingInfo'
// import a11y  from 'react-a11y'
// import {whyDidYouUpdate} from 'why-did-you-update'

require('../static/styles/backend.scss')

const APP_NAME = 'Musbi'

const root = document.getElementById('root')

const renderApp = (AppComp) => {
  render(<AppContainer><AppComp /></AppContainer>, root)
}

function main() {

  if (!window.APP_CONFIG) {
    throw new Error('APP_CONFIG not found')
  }

  renderApp(App)
}

const loadConfigAndRender = () => {
  render(
    (<LoadingInfo>
      Loading
      {' '}
      {APP_NAME}
      {' '}
      configuration...
    </LoadingInfo>),
    root
  )

  const script = document.createElement('script')
  script.src = window.APP_CONFIG_URL

  script.onload = () => main()

  script.onerror = (error) => {
    console.error(error)
    render(
      (<LoadingInfo>
        <h1>Upps...</h1>
        <p>
          An error occured while loading the configuration for
          {APP_NAME}
          . Please try again.
        </p>
      </LoadingInfo>),
      root
    )
  }

  document.scripts[0].parentNode.insertBefore(script, document.scripts[0])
}

if (process.env.NODE_ENV === 'development') {
  // a11y(React)
  // whyDidYouUpdate(React)

  try {
    loadConfigAndRender()
  }
  catch (e) {
    render(<RedBox error={e} />, root)
  }

}
else {
  loadConfigAndRender()
}

if (module.hot) {
  module.hot.accept('./App.js', () => {
    // eslint-disable-next-line global-require
    const AppNext = require('./App')
    try {
      renderApp(AppNext, root)
    }
    catch (e) {
      render(<RedBox error={e} />, root)
    }
  })
}



// WEBPACK FOOTER //
// ./src/index.js